import React from "react";
import { dialog, Button } from "nq-component";
import Table from "../../../components/Table";
import {
  countObjectUseCase,
  deleteObjectUseCase,
  findObjectUseCase,
  upsertUseCase,
} from "../../../usecases/object";
import { InfiniteScroll } from "nq-component";
import withRouter from "../../../withRouter";
import Search from "../../../components/Search";
import BaseListPage from "../../../base/BaseListPage";
import CardView from "../../../components/common/CardView";
import ExecutiveDashboardPresenter from "./ExecutiveDashboardPresenter";
import { Card, Select, Space } from "antd";
import SingleDataChart from "./component/SingleDataChart";
import SimplePieChart from "./component/SimplePieChart";
import AgeGroup from "./component/AgeGroup";
import GenderGroup from "./component/GenderGroup";
import Progress from "../../../components/Progress";

class ExecutiveDashboardPage extends BaseListPage {
  constructor(props) {
    super(props);
    this.presenter = new ExecutiveDashboardPresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
      deleteObjectUseCase(),
      upsertUseCase()
    );
    this.state = { objects: [], count: 0, limit: 10, current: 1 };
  }

  getCollectionName() {
    return "Region";
  }

  async refetchData() {
    const objects = await this.presenter.getObjects();
    return objects;
  }

  handleDisplayValue(key, data) {
    switch (key) {
      case "Users":
        return (
          <div>
            <Card
              key={key}
              title={key}
              style={{ marginBottom: "1rem" }}
              extra={
                <Button
                  className="btn bg-white border border-primary text-primary"
                  onClick={() => this.presenter.UserGenerateExcel(data)}
                >
                  <i className="bi bi-filetype-csv" /> CSV
                </Button>
              }
            >
              <SingleDataChart value={data.length} />
            </Card>
          </div>
        );
      case "Employees":
        return (
          <div>
            <Card
              key={key}
              title={key}
              style={{ marginBottom: "1rem" }}
              extra={
                <Button
                  className="btn bg-white border border-primary text-primary"
                  onClick={() => this.presenter.EmployeeGenerateExcel(data)}
                >
                  <i className="bi bi-filetype-csv" /> CSV
                </Button>
              }
            >
              <SingleDataChart value={data.length} />
            </Card>
          </div>
        );
      case "Section":
        return (
          <Card
            key={key}
            title={key}
            style={{ marginBottom: "1rem" }}
            extra={
              <Button
                className="btn bg-white border border-primary text-primary"
                onClick={() =>
                  this.presenter.plantillaGenerateExcel(
                    this.state.OCOM,
                    this.state.Location,
                    this.state.Region,
                    this.state.Subport,
                    this.state.Division,
                    this.state.Section
                  )
                }
              >
                <i className="bi bi-filetype-csv" /> CSV
              </Button>
            }
          >
            <div className="row p-2 mt-2">
              {[
                { title: "OCOM", value: this.state.OCOM },
                { title: "Location", value: this.state.Location },
                { title: "Region", value: this.state.Region },
                { title: "Subport", value: this.state.Subport },
                { title: "Division", value: this.state.Division },
                { title: "Section", value: this.state.Section },
              ].map(({ title, value }) => {
                const denseLevel = [
                  "Region",
                  "Subport",
                  "Division",
                  "Section",
                ].includes(title);
                return (
                  <div
                    key={title}
                    className={`${denseLevel ? "col-12" : "col-lg-6"} border rounded-2 mb-3`}
                    style={{ overflow: "hidden" }}
                  >
                    <SimplePieChart
                      title={title}
                      value={value}
                      employee={this.state.Employees}
                    />
                  </div>
                );
              })}
            </div>
          </Card>
        );
      case "Age Group":
        return (
          <div>
            <Card
              key={key}
              title={key}
              style={{ marginBottom: "1rem" }}
              extra={
                <Button
                  className="btn bg-white border border-primary text-primary"
                  onClick={() => this.presenter.ageGroupGenerateExcel(data)}
                >
                  <i className="bi bi-filetype-csv" /> CSV
                </Button>
              }
            >
              <AgeGroup value={data} />
            </Card>
          </div>
        );
      case "Gender":
        return (
          <div>
            <Card
              key={key}
              title={key}
              style={{ marginBottom: "1rem" }}
              extra={
                <Button
                  className="btn bg-white border border-primary text-primary"
                  onClick={() => this.presenter.genderGenerateExcel(data)}
                >
                  <i className="bi bi-filetype-csv" /> CSV
                </Button>
              }
            >
              <GenderGroup
                // title={"Gender"}
                value={this.state.OCOM}
                employee={this.state.Employees}
              />
            </Card>
          </div>
        );
      default:
        return <p>No data available for {key}</p>;
    }
  }

  render() {
    const schema = this.getSchema(this.getCollectionName());
    const { selected } = this.state;
    if (!schema) return <Progress />;

    const options = ["Users", "Employees", "Section", "Age Group", "Gender"];

    return (
      <>
        <div className="overflow-auto" style={{ marginTop: "5rem" }}>
          <InfiniteScroll className="h-100" loadMore={this.loadMore.bind(this)}>
            <div className="p-3 p-lg-4">
              <div
                className="d-flex mb-4"
                style={{ borderBottom: "1.5px solid #d3d3d3" }}
              >
                <p style={{ fontSize: ".9rem", color: "rgba(0, 0, 0, .45)" }}>
                  You are here: Home {">"} Organizational Structure {">"}{" "}
                  <span
                    style={{ fontSize: "1rem", color: "rgba(0, 0, 0, .70)" }}
                  >
                    Executive Dashboard
                  </span>
                </p>
              </div>
              <CardView style={{ borderRadius: 0 }}>
                <Space direction="vertical" className={this.props.className}>
                  <Select
                    mode="multiple"
                    allowClear
                    size="normal"
                    placeholder={`Filter`}
                    onChange={this.presenter.onSelectChange.bind(this)}
                    options={options.map((item) => ({
                      label: item,
                      value: item,
                    }))}
                    style={{
                      width: "40%",
                    }}
                  />
                </Space>
              </CardView>

              {/* Display Results */}
              <div style={{ marginTop: "2rem" }}>
                {selected &&
                  selected.map((key) => {
                    const data = {
                      Users: this.state.Users,
                      Employees: this.state.Employees,
                      Section: this.state.Section,
                      "Age Group": this.state.Employees,
                      Gender: this.state.Employees,
                    };
                    return (
                      <div>
                        {Array.isArray(data[key]) && data[key].length > 0 ? (
                          this.handleDisplayValue(key, data[key])
                        ) : (
                          <p>No data available for {key}</p>
                        )}
                      </div>
                    );
                  })}
                {/* {results &&
                  Object.entries(results).map(([key, data]) => {
                    return (
                      <div>
                        {Array.isArray(data) && data.length > 0 ? (
                          this.handleDisplayValue(key, data)
                        ) : (
                          <p>No data available for {key}</p>
                        )}
                      </div>
                    );
                  })} */}
              </div>
            </div>
          </InfiniteScroll>
        </div>
      </>
    );
  }
}

export default withRouter(ExecutiveDashboardPage);
